module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_BarChart_16"],"path":[{"$":{"d":"M6,12H2V3H6Zm5-4H7v4h4Zm1-2v6h4V6Zm4,7H1V2H0V14H16Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_BarChart_16.svg
// module id = T3N2
// module chunks = 1